@if (hasIssues()) {
  <div class="validation-panel" [class.expanded]="expanded()">
    <button type="button" class="validation-summary" (click)="toggle()">
      @if (errorCount() > 0) {
        <span class="badge badge-error">{{ errorCount() }} error{{ errorCount() === 1 ? '' : 's' }}</span>
      }
      @if (warningCount() > 0) {
        <span class="badge badge-warning">{{ warningCount() }} warning{{ warningCount() === 1 ? '' : 's' }}</span>
      }
      <span class="validation-summary-label">{{ expanded() ? 'Hide details' : 'Show details' }}</span>
    </button>

    @if (expanded()) {
      <ul class="validation-list">
        @for (issue of issues(); track issue.code + (issue.nodeId || '') + (issue.branch || '')) {
          <li
            class="validation-item"
            [class.is-error]="issue.severity === 'error'"
            [class.is-warning]="issue.severity === 'warning'"
            [class.has-target]="!!issue.nodeId"
            (click)="onSelect(issue)"
          >
            <span class="validation-dot" aria-hidden="true"></span>
            <span class="validation-message">{{ issue.message }}</span>
          </li>
        }
      </ul>
    }
  </div>
}
